export default __webpack_public_path__ + "img/774b014aca49b5bb7684b766455ccbae.svg";